import { inject, provide, ref } from "vue";
import type { InjectionKey, Ref } from "vue";
import type { RejectionCategoryWithMail } from "@/composables/recruitment/useRejectionMail";
import { toId } from "@/composables/recruitment/useRecruitmentOfficeScope";

export type TScreeningRejectionCategory = NonNullable<RejectionCategoryWithMail> & {
  _id: string;
  display: string;
};

const screeningRejectionCategoriesKey: InjectionKey<Ref<TScreeningRejectionCategory[]>> = Symbol(
  "screeningRejectionCategories",
);

/** The firm's rejection reasons, loaded once by the screening page for every candidate card */
export const provideScreeningRejectionCategories = (
  categories: Ref<TScreeningRejectionCategory[]>,
) => provide(screeningRejectionCategoriesKey, categories);

export const useScreeningRejectionCategories = () => {
  const categories = inject(screeningRejectionCategoriesKey, ref([]));

  // A deleted reason is no longer listed: the candidate shows no reason
  const categoryById = (categoryId: unknown) => {
    const id = toId(categoryId);
    return id ? (categories.value.find((category) => category._id === id) ?? null) : null;
  };

  return { categories, categoryById };
};
